{
  "common" : {
    "px" : "px",
    "px_uppercase" : "PX",
    "seconds" : "segundos",
    "other" : "-- Outros --",
    "customFieldExistsError" : "Já existe um campo personalizado com este nome",
    "uniqueKeyNotUniqueError" : "Esta Chave não é única",
    "save" : "Guardar",
    "saving" : "A guardar…",
    "typeAnOption" : "Escreva uma opção",
    "unsaved" : "Não guardado",
    "noSubmissionsFound" : "Nenhum envio encontrado",
    "sortBy" : "Ordenar por",
    "clearAll" : "Limpar tudo",
    "submitSurvey" : "Enviar inquérito",
    "select" : "Selecionar",
    "data" : "dados",
    "disqualifyAfterSubmitLower" : "Desqualificar depois de enviar",
    "errorRetryAgain" : "Erro, tente novamente",
    "bubbleRadioStyleImageAlt" : "Estilo bolha do botão de opção",
    "standardRadioStyleImageAlt" : "Estilo padrão do botão de opção",
    "recurringFrequency" : {
      "once" : "Uma vez",
      "daily" : "Diariamente",
      "weekly" : "Semanalmente",
      "monthly" : "Mensalmente",
      "yearly" : "Anualmente"
    },
    "yes" : "Sim",
    "no" : "Não",
    "updated" : "Atualizado",
    "new" : "Novo(a)",
    "title" : "Título",
    "openSettings" : "Abrir Definições",
    "cloneField" : "Clonar campo",
    "removeField" : "Remover campo",
    "description" : "Descrição",
    "cannotAddThisField" : "Não pode adicionar este campo",
    "overallOnly" : "Apenas no geral",
    "nextSlideDefault" : "Diapositivo seguinte (predefinido)",
    "nextQuestion" : "Pergunta seguinte",
    "searchAddress" : "Pesquisar endereço",
    "recurringDonation" : "Doação Recorrente",
    "recurringDonationDay" : "Doação recorrente 1 dia",
    "recurringDonationWeek" : "Doação recorrente 1 semana",
    "recurringDonationMonth" : "Doação recorrente 1 mês",
    "recurringDonationYear" : "Doação recorrente 1 ano",
    "integrate" : "Integrar",
    "preview" : "Pré-visualizar",
    "back" : "Voltar",
    "alert" : "Alerta",
    "proceed" : "Prosseguir",
    "confirm" : "Confirmar",
    "cancel" : "Cancelar",
    "delete" : "Eliminar",
    "embed" : "Incorporar",
    "link" : "Ligar",
    "linkModal" : {
      "title" : "Introduzir ligação",
      "urlLabel" : "URL",
      "urlPlaceholder" : "https://www.example.com",
      "invalidUrl" : "O URL é inválido"
    },
    "iframeEmbed" : "Incorporação de iframe",
    "styles" : "Estilos",
    "options" : "Opções",
    "quickAdd" : "Adição rápida",
    "customFields" : "Campos personalizados",
    "addObjectFields" : "Adicionar campos de objeto",
    "personalInfo" : "Informações pessoais",
    "contactInfo" : "Informações de contacto",
    "submit" : "Enviar",
    "address" : "Endereço",
    "customized" : "Personalizado(a)",
    "layout" : "Esquema",
    "showLabel" : "Mostrar etiqueta",
    "showImage" : "Mostrar imagem",
    "imageLayout" : "Layout da imagem",
    "imageLayoutSettings" : "Definições de Layout de Imagem",
    "imageLayoutMode" : "Modo de esquema de imagem",
    "surveyDefault" : "Inquérito Padrão",
    "independent" : "Independente",
    "image" : "Imagem",
    "desktop" : "Ambiente de trabalho",
    "mobile" : "Móvel",
    "desktopImage" : "Imagem do ambiente de trabalho",
    "mobileImage" : "Imagem Mobile",
    "uploaded" : "Carregado",
    "changeImage" : "Alterar imagem",
    "uploadImage" : "Carregar imagem",
    "remove" : "Remover",
    "background" : "Fundo",
    "buttonBackground" : "Fundo do Botão",
    "fontColour" : "Cor do tipo de letra",
    "textFontColour" : "Cor do tipo de letra do texto",
    "subTextFontColour" : "Cor do tipo de letra do subtexto",
    "selectThemes" : "Selecionar Tema",
    "selectOne" : "Selecionar um",
    "enableIcon" : "Ativar ícone",
    "iconType" : "Tipo de ícone",
    "iconPlacement" : "Posicionamento do ícone",
    "filled" : "Preenchido",
    "textOnly" : "Só Corpo",
    "border" : "Limite",
    "borderType" : "Tipo de limite",
    "px" : "px",
    "cornerRadius" : "Raio do canto",
    "width" : "Largura",
    "padding" : "Preenchimento",
    "top" : "Topo",
    "bottom" : "Parte inferior",
    "left" : "Esquerda",
    "right" : "Direita",
    "center" : "Centro",
    "default" : "Predefinição",
    "formDefault" : "Predefinição do formulário",
    "shadow" : "Sombra",
    "color" : "Cor",
    "horizontal" : "Horizontal",
    "vertical" : "Vertical",
    "blur" : "Desfocar",
    "spread" : "Distribuir",
    "fieldStyle" : "Estilo de campo",
    "fontColor" : "Cor da fonte",
    "inputTextFillColor" : "Cor de preenchimento do texto de entrada",
    "inputTextColor" : "Cor da cor do texto de entrada",
    "primaryColor" : "Cor primária",
    "primaryColorTooltip" : "Controla a Cor para o estado de hover e o estado Dinâmico.",
    "inputTextColorTooltip" : "Gerir a Cor do Texto digitado nos Campos de comentários.",
    "mapPrimaryColorToButtonColor" : "Mapear a cor primária para a cor do botão",
    "label" : "Etiqueta",
    "fontFamily" : "Família do tipo de letra",
    "size" : "Tamanho",
    "weight" : "Peso",
    "fontWeightTooltip" : "Aplicável no caso de parágrafos",
    "fontWeightOptions" : {
      "thin" : "100 - Fino",
      "extraLight" : "200 - Extra claro",
      "light" : "300 - Claro",
      "normal" : "400 - Normal",
      "medium" : "500 - Média",
      "semiBold" : "600 - Semi negrito",
      "bold" : "700 - Negrito"
    },
    "placeholder" : "Marcador de posição",
    "customCSS" : "CSS personalizado",
    "backgroundImage" : "Imagem de fundo",
    "headerImage" : "Imagem do cabeçalho",
    "miscellaneous" : "Diversos",
    "agencyBranding" : "Marca da agência",
    "imageUploadMessage" : "Clique ou arraste um ficheiro de imagem para esta área para carregar",
    "backgroundImageTooltipMessage" : "A imagem de fundo destina-se a cobrir toda a página, fornecendo um pano de fundo visualmente apelativo para o formulário. Para ver a imagem de fundo, clique na opção Pré-visualizar.",
    "headerImageTooltipMessage" : "A imagem do cabeçalho é desenhada para cobrir toda a largura do formulário e permanece posicionada no topo do mesmo. Para ver a imagem do cabeçalho, clique na opção Pré-visualizar.",
    "onSubmit" : "Ao enviar",
    "facebookPixelID" : "ID do Facebook Pixel",
    "facebookPixelIDMessage" : "Ignore este campo se pretender utilizar este formulário/inquérito dentro de um funil",
    "facebookPixelEvents" : "Eventos Facebook Pixel",
    "onpageView" : "Ao visualizar a página",
    "stickyContact" : "Contacto fixo",
    "stickyContactMessage" : "Recorda e preenche automaticamente os detalhes de contacto quando o utilizador regressa no mesmo dispositivo e navegador.",
    "fieldDescription" : "Descrição do Campo",
    "fieldTitle" : "Título do campo",
    "queryKey" : "Chave de consulta",
    "querykeyTooltipMessage" : "A chave de consulta que pode ser utilizada como um parâmetro de URL para preencher este campo",
    "required" : "Obrigatório(a)",
    "hidden" : "Oculto(a)",
    "hiddenValue" : "Valor oculto",
    "enableCountryPicker" : "Ativar o selecionador de país",
    "altText" : "Texto alternativo",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Alinhamento",
    "imageWidth" : "Largura da imagem",
    "imageHeight" : "Altura da imagem",
    "logic" : "Lógica",
    "pleaseInput" : "Introduza",
    "editHTML" : "Editar HTML",
    "textStyle" : "Estilo de texto",
    "subText" : "Subtexto",
    "text" : "Texto",
    "buttonStyle" : "Estilo do botão",
    "fullWidth" : "Largura total",
    "htmlMessage" : "O HTML personalizado vai aqui",
    "htmlEditorHeader" : "JAVASCRIPT PERSONALIZADO / HTML",
    "htmlEditorBodyMessage" : "Adicione o seu código aqui",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Sim, guardar",
    "cancelKeep" : "Cancelar, Manter",
    "done" : "Concluído",
    "addElement" : "Adicionar elemento",
    "addUrlLike" : "Por favor, inclua URLs válidos, tais como:",
    "doNotAddRelativePath" : "Não adicionar caminhos relativos, como",
    "or" : "ou",
    "addCustomFields" : "Adicionar campos personalizados",
    "customFieldSearch" : "Pesquisar por nome",
    "enterSourceValue" : "Introduzir valor de origem",
    "shortLabel" : "Etiqueta curta",
    "shortLabelPlaceholder" : "Tipo de letra a Etiqueta curta",
    "labelPlaceholder" : "Tipo uma etiqueta",
    "fileUploadPlaceholder" : "Carregar um Ficheiro",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Preencher valores",
    "customCSSTooltip" : "O CSS personalizado tem precedência sobre o estilo e os temas do formulário e pode ter um impacto no estilo do tema.",
    "fontFamilyTooltip" : "O Construtor suporta todos os tipos de letra se não conseguir ver isso na lista. Pesquise no menu pendente",
    "useGDPRCompliantFont" : "Utilizar o tipo de letra em conformidade com o RGPD",
    "enableTimezone" : "Ativar fuso horário",
    "inputStyle" : "Estilo de entrada",
    "conditionalLogicAlertOnSubmit" : "A lógica condicional tem precedência sobre a mensagem/redirecionamento aqui",
    "conditionalLogicAlertOnShowHide" : "A lógica condicional tem precedência sobre as definições ocultas aqui",
    "placeholderFacebookPixelIdInput" : "Introduza o ID do Facebook Pixel",
    "doNotShowMessage" : "Não mostrar novamente",
    "creatingForm" : "Crie o seu Formulário...",
    "creatingSurvey" : "Crie o seu Inquérito...",
    "creatingQuiz" : "Crie o seu questionário...",
    "errorCreatingForm" : "Lá foi um erro Criado o seu Formulário. Por favor, tentar novamente.",
    "errorCreatingSurvey" : "Lá foi um erro Criado o seu Inquérito. Por favor, tentar novamente.",
    "errorCreatingQuiz" : "Lá foi um erro Criado o seu questionário. Por favor, tentar novamente.",
    "redirectMessage" : "O utilizador será redirecionado para:",
    "themes" : {
      "themes" : "Temas",
      "alertThemeMessage" : "Mudar de tema resultará na perda de todas as modificações de estilo atuais.",
      "useTheme" : "Utilizar tema",
      "removeTheme" : "Remover tema"
    },
    "box" : "Caixa",
    "line" : "Linha",
    "message" : "Mensagem",
    "openUrl" : "Redirecionar para URL",
    "borderTypeList" : {
      "dotted" : "Pontilhado",
      "dashed" : "Tracejado",
      "solid" : "Sólido",
      "none" : "Nenhum"
    },
    "button" : "Botão",
    "emailNotification" : "Notificação por e-mail",
    "emailNotificationSubheader" : "Receba um e-mail quando alguém preencher o seu formulário",
    "subject" : "Assunto",
    "emailTo" : "E-mail (Para)",
    "senderName" : "Nome do remetente",
    "senderNameWarning" : "O seu (nome da subconta) será adicionado se for deixado em branco",
    "emailError" : "É obrigatório, pelo menos, um endereço de e-mail",
    "emailTooltip" : "O primeiro endereço de e-mail é designado para o campo \"Para\". Todos os endereços de e-mail subsequentes serão incluídos no campo \"Cc\".",
    "clear" : "Limpar",
    "filter" : "Filtrar",
    "noResults" : "Nenhum resultado",
    "search" : "Pesquisar",
    "showNotificationsSettings" : "Mostrar definições de notificações",
    "emailServicePaid" : "Esta funcionalidade é um serviço pago e será cobrada com base na sua utilização.",
    "integration" : "Integração",
    "validation" : {
      "fieldRequired" : "O Campo é Necessário",
      "maxLengthExceeded" : "Máximo Comprimento excedido ({max} Caráter)"
    },
    "securityValidation" : {
      "title" : "Problemas de segurança detetados. Não são permitidos os seguintes itens:",
      "cookieAccess" : "Detetado acesso a cookies (document.cookie). Isto não é permitido por razões de segurança.",
      "storageAccess" : "localStorage.getItem() - a leitura do localStorage não é permitida.",
      "evalUsage" : "A utilização de eval() não é permitida, pois pode executar código arbitrário.",
      "dynamicFunction" : "A criação dinâmica de funções (new Function) não é permitida por motivos de segurança.",
      "stringExecution" : "Não é permitido transmitir strings para setTimeout/setInterval, pois pode executar código arbitrário. Em vez disso, utilize referências de função."
    },
    "products" : {
      "subscriptionBadge" : "Assinatura",
      "trialBadge" : "Avaliação gratuita de {days} dia",
      "setupFee" : "Taxa de Configuração Única",
      "quantity" : "Quantidade",
      "productImageAlt" : "Imagem do produto",
      "bumpIconAlt" : "Ícone de aumento"
    },
    "payment" : {
      "payments" : "Pagamentos",
      "connected" : "Conectado(a)",
      "connect" : "Conectar",
      "liveModeOn" : "Modo publicado",
      "status" : "Estado",
      "test" : "Teste",
      "live" : "Publicado",
      "paymentFields" : "Campos de pagamento",
      "suggestAnAmount" : "Sugerir um montante",
      "recurringPayments" : "Pagamentos Recorrentes",
      "selectCurrency" : "Selecionar moeda",
      "tagActiveBGColor" : "Cor da etiqueta ativa",
      "includeOtherAmount" : "Incluir outro montante",
      "footerInfo" : "Informações do rodapé",
      "paymentType" : "Tipo de pagamento",
      "sellProducts" : "Vender produtos",
      "customAmount" : "Montante personalizado",
      "collectPayment" : "Cobrar pagamento",
      "generalSettings" : "Campos gerais",
      "securePayments" : "*100% Bloquear e pagamentos seguros*",
      "error" : {
        "addMainProductFirst" : "Adicionar um produto PRIMÁRIO primeiro",
        "priceNotFoundForBumpProduct" : "Preço não encontrado para o Produto adicional",
        "productAlreadyAdded" : "Produto já adicionado"
      },
      "product" : {
        "addProduct" : "Adicionar produto",
        "productSettings" : "Definições do produto",
        "bumpTag" : "Aumento",
        "settingsAria" : "Definições do produto",
        "deleteAria" : "Eliminar produto",
        "selectProduct" : "Selecionar produto",
        "editThisProduct" : "Para editar este produto",
        "clickHere" : "Clique aqui",
        "show" : "Mostrar",
        "description" : "Descrição",
        "image" : "Imagem",
        "layoutSettings" : "Definições de layout",
        "singleColumn" : "Coluna única",
        "twoColumn" : "Duas colunas",
        "threeColumn" : "Três colunas",
        "maxProductError" : "São permitidos, no máximo, 20 produtos num formulário",
        "productSelectPlaceholder" : "Selecione um produto",
        "orderConfirmation" : "Confirmação da encomenda",
        "orderConfirmationWarning" : "A página de confirmação da encomenda será apresentada assim que o pagamento for efetuado com sucesso",
        "quantity" : "Quantidade",
        "createProduct" : "Para criar um produto",
        "noProductsAdded" : "Ainda não há produtos adicionados",
        "productsWillShowHere" : "Depois de utilizar os produtos Incluir, eles mostrarão a Direita aqui",
        "chooseProductType" : "Selecionar Produto Tipo",
        "mainProduct" : "PRIMÁRIO Produto"
      },
      "bumProduct" : {
        "price" : "Preço",
        "variant" : "Variante",
        "headline" : "Título",
        "otoHeadline" : "Título OTO",
        "otoText" : "OTO Corpo",
        "enableImage" : "Ativar Imagem",
        "imageMessage" : "Agarremos a Predefinição Produto Imagem",
        "orUploadADifferentImage" : "Ou Carregar uma Imagem diferente",
        "bumpProducts" : "Produtos adicionais",
        "bumpProduct" : "Produto adicional",
        "enableBump" : "Ativar",
        "orderBumpStyle" : "Estilo Oferta adicional na encomenda",
        "classic" : "Clássico",
        "modern" : "Moderno",
        "icon" : "Ícone",
        "bumpTemplate" : "Selecionar Modelo",
        "highlightText" : "Destacar Corpo",
        "showPrice" : "Mostrar Preço",
        "bumpPriceColor" : "Preço adicional",
        "bumpIconColor" : "Ícone de adicional",
        "bumpBackgroundColor" : "Fundo",
        "highlightTextColor" : "Destacar Corpo",
        "headlineColor" : "Título",
        "otoHeadlineColor" : "Título OTO",
        "otoTextColor" : "OTO Corpo",
        "bumpBorderColor" : "Limite de aumento",
        "priceRequired" : "O preço é necessário",
        "headlineRequired" : "O título é necessário",
        "otoHeadlineRequired" : "O título OTO é obrigatório",
        "otoTextRequired" : "O texto OTO é obrigatório",
        "bumpProductTooltip" : "Um Pequeno Suplemento ofertado durante a Finalização de compra para o Multiplicar Ordenar Valor. Os clientes podem Incluir com um clique Individual .",
        "templateOne" : "Modelo 1",
        "templateTwo" : "Modelo 2",
        "templateThree" : "Modelo 3",
        "animationIcon" : {
          "none" : "Nenhum",
          "arrow" : "Seta",
          "fire" : "Dispensar",
          "plus" : "Mais",
          "giftBox" : "Caixa de presente",
          "timer" : "Contagem decrescente",
          "cracker" : "Sítio Web",
          "snack" : "Snack",
          "partyBalloon" : "Balão de festa",
          "flash" : "Instantâneo",
          "money" : "Moeda",
          "spaceShuttle" : "Vaivém Espaço"
        }
      },
      "coupons" : {
        "coupons" : "Cupões",
        "enableCoupon" : "Ativar cupão",
        "couponAlignment" : "Alinhamento do cupão",
        "left" : "Esquerda",
        "right" : "Direita",
        "fullWidth" : "Largura total",
        "tooltipMessage" : "Definir a posição da introdução do cupão a partir dos seguintes tipos"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Endereço de preenchimento automático",
      "addressfields" : "Campos de endereço",
      "placeholderSearch" : "Pesquisar um endereço",
      "autoCompleteTooltip" : "Fornece a capacidade de pesquisar e preencher automaticamente o endereço.",
      "streetAddress" : "Endereço da rua",
      "autoCompleteAddressTitle" : "Endereço de término automático",
      "newBadge" : "novo",
      "defaultLabel" : "Endereço",
      "searchPlaceholder" : "Pesquisar Endereço",
      "mandataorySearch" : {
        "title" : "Necessário para selecionar o endereço in barra de pesquisa",
        "primaryText" : "Preencher automaticamente apenas para Endereço da rua",
        "secondaryText" : "Quando Ativado, Quando o Utilizador interage com o Campo de Endereço, Depois deve selecionar um Endereço válido para Prosseguir.",
        "secondaryText1" : "Quando Desativado Depois, podem Prosseguir sem selecionar um Endereço in barra Pesquisar."
      }
    },
    "autoResponder" : "Resposta automática",
    "autoResponderSubheader" : "Enviar um e-mail automático à pessoa que envia o formulário (o e-mail inclui uma cópia das informações introduzidas no formulário)",
    "replyToEmail" : "Responder ao e-mail",
    "open" : "Abertas",
    "won" : "Ganhas",
    "lost" : "Perdidas",
    "abandon" : "Abandonar",
    "selectAPipeline" : "Selecionar uma pipeline",
    "stage" : "Fase",
    "status" : "Estado",
    "opportunityValue" : "Valor da oportunidade",
    "createNewPipeline" : "Criar novo pipeline",
    "editOpportunitySettings" : "Editar definições da oportunidade",
    "contact" : "Contacto",
    "opportunity" : "Oportunidade",
    "business" : "Empresa",
    "add" : "Adicionar",
    "manage" : "Gerir",
    "more" : "Mais",
    "opportunityHeading" : "Onde pretende que a sua oportunidade seja atualizada?",
    "date" : {
      "dateSettings" : "Definições de data",
      "dateFormat" : "Formato da data",
      "dateSeparator" : "Separador de data",
      "dateFormatTooltipMessage" : "Selecione um formato de data. D significa dia, M significa meses e A significa ano",
      "dateSeparatorTooltipMessage" : "Selecione um separador que irá separar o dia, mês e ano no formato selecionado em Formato de data",
      "disablePicker" : "Desativar Selecionador"
    },
    "restoreVersion" : "Restaurar versão",
    "versionHistory" : "Histórico da versão",
    "errorMessage" : "Erro, tente novamente",
    "version" : "Versão:",
    "currentVersion" : "Versão atual",
    "messageStyling" : "Estilos de mensagens",
    "validateEmailHeader" : "Validar e-mail",
    "validateEmailDescription" : "O botão fica visível assim que o utilizador introduzir o respetivo e-mail. Esta funcionalidade foi criada para ajudar a gerar oportunidades potenciais de qualidade.",
    "verifyEmail" : "Verifique o Email",
    "validatePhoneHeader" : "Validar Telefone",
    "validatePhoneDescription" : "O botão fica visível quando o utilizador introduzir o respetivo telefone. Esta funcionalidade foi criada para ajudar a gerar oportunidades potenciais de qualidade.",
    "verifyPhone" : "Verificar Telefone",
    "validatePhoneWarning" : "Para ativar a verificação OTP por SMS, certifique-se de que o seu número de telefone configurado nas suas definições de localização",
    "addAnotherTnc" : "Adicione outro T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Escreva DELETE para confirmar",
    "marginPadding" : "Margem e preenchimento",
    "style" : {
      "formLayoutType" : "Tipo de formulário",
      "layoutType" : "Tipo de esquema",
      "surveyType" : "Tipo de Inquérito",
      "oneColumn" : "Uma coluna",
      "twoColumn" : "Duas colunas",
      "singleLine" : "Linha única",
      "fieldWidth" : "Largura do campo",
      "labelAlignment" : {
        "labelAlignment" : "Alinhamento da etiqueta",
        "labelWidth" : "Largura da etiqueta"
      },
      "fieldSpacing" : "Espaçamento entre campos",
      "imageFieldSpacing" : "Espaçamento entre imagens e campos",
      "imageCornerRadius" : "Raio dos cantos da imagem",
      "color" : "cor",
      "fontColor" : "Cor do tipo de letra",
      "inputBackgroundColor" : "Cor de fundo de entrada",
      "inputBorder" : "Limite de entrada",
      "layout" : "Esquema",
      "colorsAndBackground" : "Cores & Fundo",
      "imageLayout" : {
        "imageLayout" : "Layout da imagem",
        "showImage" : "Mostrar imagem",
        "image" : "Imagem",
        "desktop" : {
          "topFixed" : "Superior fixo",
          "leftCenter" : "Centro Esquerdo",
          "rightCenter" : "Centro Direito",
          "leftFixed" : "Esquerda Fixo",
          "rightFixed" : "Fixado à direita",
          "background" : "Fundo"
        },
        "mobile" : {
          "header" : "Cabeçalho",
          "background" : "Fundo"
        }
      },
      "focusPoint" : {
        "title" : "Ponto Focal",
        "reset" : "Repor",
        "noImage" : "Nenhuma imagem carregada"
      },
      "advanceSettings" : "Definições avançadas",
      "inputField" : "Campo de entrada",
      "borderWidth" : "Largura do limite",
      "borderColor" : "Cor do limite",
      "borderStyle" : "Estilo do limite",
      "fontSize" : "Tamanho do tipo de letra",
      "fontWeight" : "Espessura do tipo de letra",
      "labelColor" : "Cor da etiqueta",
      "placeholderColor" : "Cor do marcador de posição",
      "shortLabelColor" : "Cor da etiqueta curta"
    },
    "replyToTooltip" : "Personalize o endereço de e-mail predefinido do campo Responder a utilizando {'{'}{'{'}contact.email{'}'}{'}'} para permitir respostas ao contacto que envia o formulário.",
    "content" : "Conteúdo",
    "calculations" : "Cálculos",
    "uploadOptions" : "Opções de Carregamento",
    "opportunitySettingsWarning" : "Configure as definições da oportunidade clicando no botão Editar definições da oportunidade.",
    "startValue" : "Valor de Início",
    "endValue" : "Valor Fim",
    "today" : "Hoje",
    "thisWeek" : "Esta semana",
    "last7Days" : "Últimos 7 dias",
    "thisMonth" : "Este mês",
    "last30Days" : "Últimos 30 dias",
    "question" : "Pergunta",
    "createContactOnPartialSubmission" : "Criar contacto no envio parcial",
    "howItWorks" : "Como é que funciona?",
    "createContactOnPartialSubmissionDescription" : "Termine o diapositivo e clique em \"Seguinte\". Será criado e guardado automaticamente um novo contacto.",
    "swapWarningMessageSurvey" : "A edição ou troca de opções terá impacto neste campo personalizado em todos os locais onde o campo é utilizado. Também pode repor a lógica condicional. ",
    "swapWarningMessageForm" : "A edição ou troca de opções terá impacto neste campo personalizado em todos os locais onde o campo é utilizado. ",
    "migrationWarningMessage" : "Esta funcionalidade foi migrada para a Lógica condicional do inquérito.",
    "optionLabel" : "Etiqueta da opção",
    "calculationValue" : "Valor de cálculo",
    "addOption" : "Adicionar Opção",
    "enableCalculations" : "Ativar cálculos",
    "allowOtherOption" : "Permitir outra opção",
    "productSelectionSubtext" : "Ativar Individual Ou múltipla Seleção de produto",
    "multi" : "Multi",
    "single" : "Individual",
    "productSelectionHeading" : "Seleção de Produto",
    "spreadToColumns" : "Distribuir por colunas",
    "columns" : "Colunas",
    "customstyle" : "Estilo",
    "standard" : "Padrão",
    "bubble" : "Bubble",
    "integratePopup" : {
      "title" : "Integrar formulário",
      "embedCode" : "Código de incorporação",
      "useInFunnelOrEmbedCode" : "Utilizar no funil/código de Incorporação",
      "iframeEmbed" : "Incorporar de iframe",
      "layout" : {
        "title" : "Incorporar tipo de esquema",
        "description" : "Selecione um esquema a incorporar num funil ou sítio Web externo",
        "allowMinimize" : "Permitir minimização",
        "minimizedTitlePlaceholder" : "Título minimizado",
        "leftAlignAlt" : "Alinhar à esquerda",
        "rightAlignAlt" : "Alinhar à direita"
      },
      "triggerType" : "Tipo de acionador",
      "triggers" : {
        "seconds" : "segundos"
      },
      "activation" : {
        "title" : "Opções de ativação",
        "visit" : "visita"
      },
      "deactivation" : {
        "title" : "Opções de desativação",
        "times" : "vezes"
      },
      "copyEmbedCode" : "Copiar código de incorporação",
      "copyFormLink" : "Copiar ligação do formulário",
      "openFormLink" : "Abrir ligação do formulário",
      "invalidInput" : "Entrada inválida!",
      "funnel" : {
        "funnel" : "Funil",
        "chooseStep" : "selecionar um passo",
        "copyCodeAndOpenFunnel" : "Copiar Código e Abrir o Funil"
      },
      "share" : {
        "share" : "Partilhar",
        "shareViaSocials" : "Partilhar Via redes sociais",
        "copyLink" : "Copiar ligação"
      },
      "email" : {
        "email" : "E-mail",
        "shareViaEmail" : "Partilhar por e-mail",
        "emailButton" : "E-mail",
        "blankTemplate" : "Modelo em branco",
        "emailMarketingTemplates" : "Modelos de Marketing E-mail",
        "or" : "Ou",
        "chooseTemplate" : "Escolha entre os seus modelos",
        "continue" : "Continuar"
      }
    },
    "rating" : {
      "icon" : "Ícone",
      "iconAlignment" : "Alinhamento do Ícone",
      "count" : "Contagem",
      "lowestRating" : "Classificação mínima",
      "highestRating" : "Classificação máxima",
      "iconSelectedState" : "Estado Selecionado do Ícone",
      "iconUnselectedState" : "Estado do Ícone não selecionado",
      "rating" : "Classificação",
      "ratingSettings" : "Definições de classificação",
      "calculationType" : {
        "calculationType" : "Como Arquivar Campos de Classificação in Personalizado Campos",
        "calculationTypeTooltip" : "Quando utilizado Frequência algo 4 De 5 estrelas, significa: - Total: 4 De 5 - Percentagem: 80 - Fração: 0.8",
        "absolute" : "Total",
        "percentage" : "Percentagem",
        "fraction" : "Fração"
      }
    },
    "desktopMode" : "Modo de ambiente de trabalho",
    "mobileMode" : "Modo móvel",
    "versions" : "Variantes",
    "advanced" : "Avançado",
    "edit" : "Editar",
    "settings" : "Definições",
    "submissions" : "Envios",
    "undo" : "Anular",
    "redo" : "Refazer",
    "customValues" : "Valores personalizados",
    "pickBgFromImage" : "Adiciona um desfoque ao fundo da sua caixa de mensagens. Se escolher uma cor de fundo para a caixa de mensagem, aparecerá sobre a caixa de mensagem desfocada.",
    "pickBgFromImageTip" : "Escolhe uma Cor com alto Comparar para a Imagem de fundo. Mensagem: não será aplicado se o Fundo do Formulário não tiver Imagem",
    "messageBackgroundBlur" : "Desfocagem do fundo",
    "confirmationMessage" : "Mensagem de confirmação",
    "deleteOption" : "Opção de eliminação",
    "deleteConfirmationModal" : {
      "defaultDescription" : "A eliminar... uma opção terá impacto neste Campo personalizado em todos os Assentos onde o Campo é utilizado. Tem a certeza de que o utilizador deseja eliminá-lo?",
      "validationMessage" : "Insira Eliminação para Guardar.",
      "validationError" : "Insira Eliminação"
    },
    "disqualifyImmediately" : "Desqualificar imediatamente",
    "disqualifyAfterSubmit" : "Desqualificar depois de enviar",
    "generalSettings" : "Definições Geral",
    "advancedSettings" : "Definições avançadas",
    "customFieldName" : "Nome da indústria personalizado",
    "customFieldNameTooltip" : "Este Nome de Indústria é único por Personalizado Indústria.",
    "uniqueKey" : "Chave única",
    "uniqueKeyTooltip" : "Esta Chave é única por Personalizado Indústria.",
    "selectContactAssociation" : "Selecione a relação com os Contactos",
    "associations" : "Associações",
    "createNewAssociation" : "Criar nova relação",
    "selectAnAssociation" : "Selecione uma relação",
    "loadingAssociations" : "A carrregar associações...",
    "unknownAssociation" : "Associação Desconhecida",
    "manyToMany" : "Muitos para muitos",
    "failedToLoadAssociations" : "Falha ao carregar associações",
    "noAssociationsFound" : "Nenhuma associação encontrada",
    "keepThisField" : "Manter este campo",
    "association" : "Associação",
    "customObject" : "Objeto personalizado",
    "customObjects" : "Objetos personalizados",
    "object" : "Objeto",
    "editAssociation" : "Editar Relação de {objectName}",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Campos",
    "primaryFieldWarning" : "{fieldName} é um campo PRIMÁRIO para {objectSingular} e é Necessário para criar Ou atualizar um {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} é Necessário para criar ou Atualizar o Documento {objectSingular}.",
    "removeAllFields" : "Limpar todos os {objectSingular} Campos",
    "customObjectsFallback" : "Objetos personalizados",
    "noneAssociation" : "Nenhum",
    "noneAssociationDescription" : "Nenhuma Relação com Contactos (sem Campos de Contacto aqui)",
    "survey" : {
      "layoutType" : "Tipo de Inquérito",
      "oneQuestionPerPage" : "Uma Pergunta de Cada Vez",
      "allQuestionsOnePage" : "Muitos de cada vez"
    },
    "quizQuestions" : "Questionário consulta, pedidos, pedido",
    "choiceElements" : "Componentes de escolha",
    "otherElements" : "Outros Componentes",
    "listEditor" : {
      "prefillValueHeader" : "Pré-preencher Valor",
      "labelPlaceholder" : "Etiqueta",
      "valuePlaceholder" : "Valor",
      "optionRequiredError" : "A opção Campo é Necessário"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Adicionar Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "número"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipos de Ficheiro",
      "all" : "todos",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/ JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Ok",
    "allowMultipleFiles" : "Ativar Vários Ficheiros",
    "maxFileLimit" : "Limite Máximo de Ficheiro",
    "privacyPolicy" : "Política de privacidade",
    "termsOfService" : "Termos de Serviço",
    "colorPicker" : {
      "brandColors" : "Cores da Marca",
      "defaultColors" : "Cores predefinidas",
      "globalCustomColors" : "Cores personalizadas globais"
    },
    "billingFrequency" : "Frequência de Faturação",
    "otherAmount" : "Outro montante",
    "exampleUrlPlaceholder" : "https://www.example.com",
    "checkboxStyles" : {
      "standardAlt" : "Estilo padrão de caixa de seleção",
      "bubbleAlt" : "Estilo bolha da caixa de verificação"
    },
    "previewIcons" : {
      "exportAlt" : "Ícone de exportação",
      "shipmentAlt" : "Ícone de entrega",
      "resultAlt" : "Ícone da página de resultados"
    },
    "examples" : {
      "sampleUrl" : "https://example.com"
    },
    "showing" : "Apresentação",
    "of" : "de",
    "enterCouponCode" : "Introduza o código do cupão",
    "apply" : "Aplicar",
    "paymentWillBeProcessed" : "O pagamento será processado assim que avançar para o passo seguinte",
    "paymentWillBeProcessedNextSlide" : "O pagamento será processado assim que o utilizador avançar para o diapositivo seguinte",
    "showThisAlertToUsers" : "Mostre este alerta aos utilizadores",
    "sixteenDigitCardNumber" : "Número de cartão com 16 dígitos",
    "mmYy" : "MM/AA",
    "cvc" : "CVC",
    "pleaseFillRequiredFields" : "Preencha todos os campos obrigatórios!",
    "opportunitySettingsIncomplete" : "Definições da oportunidade incompletas",
    "opportunitySettingsIncompleteDescription" : "Este formulário inclui campos de oportunidade, mas as definições da oportunidade não foram atualizadas. Configure as definições da oportunidade para poder guardar o formulário.",
    "ariaAttributes" : {
      "iconSearch" : "Pesquisa de ícones"
    },
    "alt" : {
      "standardRadioStyle" : "Estilo padrão do botão de opção",
      "bubbleRadioStyle" : "Estilo bolha do botão de opção"
    },
    "value" : "Valor",
    "jumpTo" : "Saltar para",
    "thankYouJohnDoe" : "Obrigado, John Doe",
    "total" : "Total",
    "urlExamples" : {
      "simple" : "exemplo.pt",
      "https" : "https://exemplo.pt",
      "withPath" : "example.com/path",
      "fullPath" : "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Escolha Individual",
      "multipleChoice" : "Escolha múltipla",
      "yesNo" : "Sim / Não",
      "shortAnswer" : "Curto Respondedo",
      "longAnswer" : "Longo Respondedo",
      "number" : "número",
      "singleDropdown" : "Menu Individual suspenso",
      "multiDropdown" : "Multi Menu suspenso"
    },
    "personal" : {
      "fullName" : "Nome Completo",
      "firstName" : "Nome próprio",
      "lastName" : "último Nome",
      "dateOfBirth" : "Data de nascimento",
      "phone" : "Telefone",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Botão"
    },
    "integration" : {
      "sellProducts" : "Vender produtos",
      "collectPayment" : "Recolher pagamento"
    },
    "address" : {
      "address" : "Endereço",
      "streetAddress" : "Endereço da rua",
      "city" : "Cidade",
      "state" : "Estado",
      "country" : "País",
      "postalCode" : "Código Postal",
      "organization" : "Grupo",
      "website" : "Sítio Web",
      "websitePlaceholder" : "O URL da Web vai aqui"
    },
    "text" : {
      "singleLine" : "Linha Individual",
      "multiLine" : "Linha",
      "textBoxList" : "Texto Quadrado Lista"
    },
    "choiceElements" : {
      "singleDropdown" : "Menu Individual suspenso",
      "multiDropdown" : "Multi Menu suspenso",
      "checkbox" : "Caixa de verificação",
      "radio" : "Rádio"
    },
    "customized" : {
      "text" : "Clicar para editar este texto",
      "html" : "HTML",
      "htmlPlaceholder" : "O HTML Personalizado vai aqui",
      "captcha" : "Captcha",
      "source" : "Fonte",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Aceito os termos e condições do Emido Via a empresa. Ao fornecer o meu Número de telefone, Aceito com as mensagens da Herdar Texto De a empresa.",
      "score" : "Pontuação"
    },
    "other" : {
      "image" : "Imagem",
      "fileUpload" : "Carregar de Ficheiro",
      "monetary" : "Monetário",
      "number" : "número",
      "datePicker" : "Selecionador de Data",
      "signature" : "Assinatura"
    },
    "customstyle" : "Estilo",
    "standard" : "Padrão",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Inquérito",
    "survyeStyle" : "Estilo do inquérito",
    "surveyName" : "Nome do inquérito",
    "surveyElement" : "Elemento do inquérito",
    "addSurveyElement" : "Adicionar elemento do inquérito",
    "cloneSlide" : "Clonar diapositivo",
    "unsavedAlertMessage" : "O inquérito tem trabalho não guardado. Tem a certeza de que pretende sair e descartar todo o trabalho não guardado?",
    "thirdPartyScriptAlertMessage" : "Os scripts de terceiros dentro do bloco HTML podem fornecer funcionalidades poderosas, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Por conseguinte, recomendamos que reveja o conteúdo deste script antes de o guardar no inquérito.",
    "integrateHeader" : "Integrar Inquérito",
    "integrateSubHeader" : "Utilize as seguintes opções para integrar o inquérito personalizado no seu Website",
    "integrateCopyLinkMessage" : "Copie a ligação abaixo e partilhe-a facilmente onde quiser.",
    "onSurveySubmission" : "Ao enviar o inquérito",
    "surveySettings" : "Definições do inquérito",
    "oneQuestionAtTime" : "Uma pergunta de cada vez",
    "backButton" : "Botão Voltar",
    "backButtonTooltipMessage" : "O botão Voltar ajuda os utilizadores a se moverem para o diapositivo anterior",
    "disableAutoNavigation" : "Desativar navegação automática",
    "disableAutoNavigationTooltipMessage" : "Navega automaticamente para o Seguinte Deslizar Depois de a Utilizador responder.",
    "autoNavigation" : "Navegação Automático",
    "autoNavigationTooltipMessage" : "Navega automaticamente para o Seguinte Deslizar Depois de a Utilizador responder.",
    "progressBar" : "Barra de progresso",
    "progressBarTooltipMessage" : "Desativar esta opção remove a barra de progresso do inquérito",
    "disableAnimation" : "Desativar animação",
    "disableAnimationTooltipMessage" : "Se desativar esta opção, desativa a animação de transição de diapositivos",
    "scrollToTop" : "Deslocar para o topo",
    "scrollToTopTooltipMessage" : "Se ativado, o inquérito é deslocado para o topo no diapositivo seguinte",
    "submitSurvey" : "Enviar inquérito",
    "disqualifyImmediately" : "Desqualificar imediatamente",
    "disqualifyAfterSubmit" : "Desqualificar depois de enviar",
    "disqualifyAfterSubmitLowerCase" : "Desqualificar depois de enviar",
    "footerHTML" : "HTML do rodapé",
    "footerHTMLMessage" : "Pode escrever CSS personalizado (utilizando a etiqueta de estilo) e HTML dentro da mesma caixa",
    "editFooter" : "Editar rodapé",
    "disqualifySettings" : "Definições de desqualificação",
    "disqualifyImmediatelyLabel" : "Imediatamente",
    "disqualifyAfterSubmitLabel" : "Após o envio",
    "slideConflictAlertMessage" : "Este diapositivo contém várias perguntas que têm uma lógica definida. Isto pode causar alguns comportamentos não intencionais",
    "addSlide" : "Adicionar diapositivo",
    "settings" : "Definições",
    "delete" : "Eliminar",
    "slideDeleteAlertMessage" : "Tem a certeza de que pretende eliminar este diapositivo?",
    "slideDeleteBetweenAlertMessage" : "Isto irá reorganizar os outros diapositivos, tem certeza de que pretende eliminar este diapositivo?",
    "slideLabel" : "Diapositivo {n}",
    "slideName" : "Nome do diapositivo",
    "slidePosition" : "Posição do diapositivo",
    "jumpTo" : "Saltar para",
    "jumpToSubText" : "Vá para um diapositivo específico",
    "enableTimezoneSurvey" : "Ativar essa opção irá captar as informações sobre o fuso horário do indivíduo que vai enviar o inquérito",
    "footer" : {
      "footer" : "Rodapé",
      "enableNewFooter" : "Ativar novo rodapé",
      "stickToSurvey" : " Manter informações do inquérito",
      "backgroundFill" : "Preenchimento de fundo",
      "footerHeight" : "Altura do rodapé",
      "enableProgressBar" : "Ativar barra de progresso",
      "buttons" : "Botões",
      "button" : "Botão",
      "buttonType" : "Tipo de botão",
      "fillNext" : "Preencher (seguinte)",
      "fillPrevious" : "Preencher (anterior)",
      "fillSubmit" : "Preencher (Enviar)",
      "textColor" : "Texto do botão",
      "position" : "Posição",
      "previousText" : "Anterior (texto)",
      "nextText" : "Seguinte (texto)",
      "submitText" : "Enviar (texto)",
      "fillComplete" : "Preenchimento concluído",
      "fillInactive" : "Preenchimento inativo",
      "footerType" : "Tipo de rodapé",
      "stickToCard" : "Manter informações do cartão",
      "stickToPage" : "Manter informações da página",
      "stepTextColor" : "Cor do Passo Corpo",
      "progressBarFill" : "Barra de progresso Preencher",
      "progressBarInactive" : "Barra de progresso Inativo",
      "arrowFill" : "Preencher de Seta",
      "submitColorMobile" : "Enviar (Cor)",
      "arrowFillColor" : "Cor de Preencher da Seta",
      "buttonTypes" : {
        "textAndArrow" : "Texto e seta",
        "onlyText" : "Apenas Texto",
        "onlyArrow" : "Apenas seta"
      },
      "positions" : {
        "leftAndRight" : "Esquerda e direita"
      },
      "placeholders" : {
        "prev" : "Anterior",
        "next" : "Seguinte",
        "submit" : "Enviar"
      }
    },
    "surveyNotfication" : "Notificação de inquérito",
    "style" : {
      "surveyPadding" : "Preenchimento no inquérito"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorporar ou partilhar inquérito",
      "share" : {
        "openFormLink" : "Abrir Ligar, vincular do Inquérito"
      },
      "email" : {
        "emailSubheader" : "Criar um e-mail em branco e integrar o seu Inquérito, Ou selecione um Modelo e Incorporar-o imediatamente."
      }
    },
    "autoResponderSubheader" : "Enviar um e-mail automático para a pessoa que envia o inquérito (o e-mail inclui uma cópia das informações introduzidas)",
    "sendSubmissionsAsPdf" : "Envie a submissão do inquérito como um PDF",
    "switchToOneQuestionAtTimeOn" : "Ativar \" One Questão em a Data \" interrompe a sua Lógica condicional Atual",
    "switchToOneQuestionAtTimeOff" : "Desativar \"one Questão em a Data\" tem impacto na sua Lógica Configuração condicional",
    "switchToOneQuestionAtTimeOnWarning" : "algumas condições não funcionarão mais como esperado quando as perguntas são mostradas uma a dados.",
    "switchToOneQuestionAtTimeOffWarning" : " Algumas condições criadas para o Fluxo de pergunta individual deixarão de funcionar conforme o esperado.",
    "createContactOnPartialSubmissionSubText" : "Cria um contacto quando um utilizador clica em \"Seguinte\" em qualquer diapositivo — mesmo que não conclua o inquérito.",
    "dragDrop" : {
      "imageLabel" : "Imagem {n}",
      "htmlLabel" : "HTML {n}",
      "defaultFolderName" : "Inquérito {'|'} {name}",
      "defaultTermsHtml" : "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Política de Privacidade</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Termos de Serviço</a></p>",
      "smsConsent" : "Autorizo a receção de notificações SMS, alertas e comunicações de marketing ocasionais da empresa. A frequência das mensagens varia. Podem ser aplicadas taxas de mensagens e de dados. Envie uma mensagem de texto HELP para (XXX) XXX-XXXX para obter assistência. Pode responder STOP para anular a assinatura em qualquer altura."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formulário",
    "formStyle" : "Estilo de formulário",
    "formElement" : "Elemento do formulário",
    "addFormElement" : "Adicionar elemento do formulário",
    "addConditionalLogic" : "Adicionar lógica condicional",
    "openConditionalLogic" : "Abrir lógica condicional",
    "inlineForm" : "Formulário em linha",
    "formName" : "Nome do formulário",
    "fullScreenMode" : "Modo de ecrã completo",
    "fullScreenModetooltip" : "Ativar esta opção fará com que o formulário se expanda por toda a largura do contentor, estendendo-se até ao limite da área de incorporação enquanto adere à largura do formulário.",
    "enableTimezoneForm" : "Ativar essa opção irá captar as informações sobre o fuso horário da pessoa que vai enviar o inquérito",
    "formSettings" : "Definições do formulário",
    "unsavedAlertMessage" : "O formulário tem trabalho não guardado. Tem a certeza de que pretende sair e descartar todo o trabalho não guardado?",
    "thirdPartyScriptAlertMessage" : "Os scripts de terceiros dentro do bloco HTML podem fornecer funcionalidades poderosas, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Por conseguinte, recomendamos que reveja o conteúdo deste script antes de o guardar no formulário.",
    "onFormSubmission" : "Ao enviar o formulário",
    "integrateForm" : "Integrar Formulário",
    "embedlayoutType" : "Incorporar Tipo de Esquema",
    "embedlayoutTypeSubMessage" : "Selecione um esquema a incorporar num funil ou Website externo",
    "triggerType" : "Tipo de acionador",
    "showOnScrolling" : "Mostrar ao rolar",
    "showAfter" : "Mostrar depois",
    "seconds" : "segundos",
    "alwaysShow" : "Mostrar sempre",
    "activationOptions" : "Opções de ativação",
    "activateOn" : "Ativar em",
    "visit" : "visita",
    "alwaysActivated" : "Sempre ativado",
    "deactivationOptions" : "Opções de desativação",
    "deactivateAfterShowing" : "Desativar após mostrar",
    "times" : "vezes",
    "deactiveOnceLeadCollected" : "Desativar assim que a oportunidade potencial for recolhida",
    "neverDeactivate" : "Nunca desativar",
    "copyEmbedCode" : "Copiar código de incorporação",
    "copyFormLink" : "Copiar ligação do formulário",
    "openFormLink" : "Abrir ligação do formulário",
    "inline" : "Em linha",
    "inlineDescription" : "Um formulário em linha é apresentado juntamente com o conteúdo da página como um elemento nativo. Não se sobrepõe e não pode ser fechado ou minimizado.",
    "inlineHoverDescription" : "Um formulário em linha é apresentado juntamente com o conteúdo da página como um elemento nativo. Não se sobrepõe e não pode ser fechado ou minimizado.",
    "popup" : "Pop-up",
    "popupDescription" : "Um pop-up mostra o formulário como uma sobreposição dentro de uma caixa de luz. Não pode ser minimizado, mas pode ser fechado.",
    "popupHoverDescription" : "Um pop-up mostra o formulário como uma sobreposição dentro de uma caixa de luz. Não pode ser minimizado, mas pode ser fechado.",
    "politeSlideIn" : "Mensagem subtil",
    "politeSlideInDescription" : "Uma mensagem subtil é apresentada na parte inferior do ecrã e desaparece quando é fechada",
    "politeSlideInHoverDescription" : "É apresentada na parte inferior do ecrã e desaparece quando é fechada",
    "stickySidebar" : "Barra lateral fixa",
    "stickySidebarDescription" : "Uma barra lateral fixa será apresentada na parte lateral do ecrã e pode ser minimizada num separador fixado à parte lateral da janela",
    "stickySidebarHoverDescription" : "Apresentada na parte lateral do ecrã e pode ser minimizada num separador fixado à parte lateral da janela",
    "allowMinimize" : "Permitir minimizar",
    "conditonalLogic" : {
      "conditions" : "Condições",
      "noExistingCondition" : "Nenhuma condição existente ainda",
      "freeRoamMessage" : "É livre de andar à solta sem regras, pelo menos por enquanto",
      "addNewCondition" : "Adicionar nova condição",
      "redirectToUrl" : "Redirecionar para URL",
      "displayCustomMessage" : "Apresentar mensagem personalizada",
      "disqualifyLead" : "Desqualificar oportunidade potencial",
      "showHideFields" : "Mostrar/ocultar campos",
      "jumpTo" : "Saltar para",
      "redirectToUrlSubText" : "Redirecionar o utilizador após a submissão",
      "displayCustomMessageSubText" : "Mostrar mensagens com base em entradas do Ativado Utilizador",
      "disqualifyLeadSubText" : "Filtrar entradas sob condições específicas",
      "showHideFieldsSubText" : "Modificar Campo Visibilidade de forma dinâmica",
      "openBelowUrl" : "Abrir URL abaixo",
      "showCustomMessage" : "Mostrar mensagem personalizada",
      "alertConditionDelete" : "Tem a certeza de que pretende eliminar esta condição?",
      "deleteCondition" : "Eliminar condição",
      "conditionExecutedMessage" : "As condições serão executadas de cima para baixo.",
      "allOperationOptions" : {
        "isEqualTo" : "É igual a",
        "isNotEqualTo" : "Não é igual a",
        "contains" : "Contém",
        "doesNotContain" : "Não contém",
        "startsWith" : "Começa com",
        "endsWith" : "Termina com",
        "isEmpty" : "Está vazio",
        "isFilled" : "Está preenchido",
        "before" : "Antes de",
        "after" : "Depois de",
        "greaterThan" : "Maior que",
        "lessThan" : "Menor que",
        "between" : "Entre",
        "isChecked" : "Está verificado",
        "isNotChecked" : "Não está verificado"
      },
      "logic" : {
        "if" : "Se",
        "then" : "Depois",
        "and" : "E",
        "or" : "Ou"
      },
      "phoneAlertMessage" : "Para pesquisar números de telefone com um indicativo de país, tem de incluir explicitamente o símbolo \"+\" na sua consulta de pesquisa.",
      "deleteAlertMessage" : "Tem a certeza de que pretende eliminar este campo? A condição associada a este campo também será removida.",
      "deleteField" : "Eliminar Campo",
      "jumpToDescription" : "Salte para um diapositivo específico quando as condições forem satisfeitas",
      "cycleError" : "Não é possível guardar. Ciclo detetado entre {a} e {b}",
      "jumpToSlide" : "Saltar para o diapositivo",
      "submitSurvey" : "Guardar Inquérito",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Selecione o diapositivo do qual saltar",
      "selectedSlide" : "Diapositivo selecionado",
      "typeValueHere" : "Por favor, digite um Valor aqui",
      "field" : "Indústria",
      "slide" : "Deslizar",
      "selectFieldOrSlide" : "Selecionar Campo ou Diapositivo",
      "selectFieldState" : "Selecionar Estado do Campo",
      "selectField" : "Selecionar Indústria",
      "selectOption" : "Selecionar opção",
      "jumpToTarget" : "Saltar para",
      "jumpToQuestion" : "Ir para a Questão",
      "chooseQuestion" : "Escolher pergunta",
      "includeStart" : "Incluir início",
      "includeEnd" : "Incluir fim",
      "includeValue" : "Incluir {value}",
      "hideField" : "Ocultar campo",
      "hideFields" : "Ocultar Campos",
      "showField" : "Mostrar campo",
      "showFields" : "Mostrar campos",
      "additionalRulesPrefix" : "... e",
      "additionalRulesSuffix" : "outras {ifLabel} regras ...",
      "shownTargetsWithMore" : "{shown}, mais {count}",
      "noConditionsAlt" : "Nenhuma condição ainda",
      "outcomeLabels" : {
        "show" : "Mostrar",
        "jumpTo" : "Saltar para"
      }
    },
    "minimizedTitlePlaceholder" : "Título minimizado",
    "dragYourElementFromLeft" : "Arraste os seus elementos para aqui a partir da esquerda",
    "formNotification" : "Notificação de formulário",
    "sendSubmissionsAsPdf" : "Enviar submissão do formulário como um PDF",
    "style" : {
      "formPadding" : "Preenchimento no formulário"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorporar ou partilhar formulário",
      "share" : {
        "openFormLink" : "Abrir Ligar, vincular do Formulário"
      },
      "email" : {
        "emailSubheader" : "Crie um e-mail em branco e incorpore o seu formulário, ou selecione um modelo e incorpore-o imediatamente."
      }
    },
    "choosePosition" : "Selecionar Estado",
    "testBuild" : "Construção de teste"
  },
  "quiz" : {
    "quizElement" : "Elemento do questionário",
    "quizNotification" : "Notificação de questionário",
    "viewAndCustomise" : "Ver e personalizar",
    "categoryAndScore" : "Categoria e Pontuação",
    "provideFeedback" : "Fornecer comentários",
    "addQuizElement" : "Adicionar elemento do questionário",
    "typeOfBuilder" : "Questionário",
    "addQuestions" : "Adicionar Perguntas",
    "dragAndDropQuestion" : "Arrastar e soltar um elemento da Questão aqui.",
    "addNewPage" : "Adicionar nova página",
    "editTemplate" : "Editar Modelo",
    "editResultPage" : "Editar página de resultados",
    "clonePage" : "Clonar página",
    "category" : {
      "category" : "Categoria",
      "watchVideo" : "Veja este vídeo para saber mais Acerca de Como a categoria afetam a página dos resultados!",
      "useCategoryWhen" : "Utilizar categorias quando",
      "manageCategories" : "Gerir Categorias",
      "howItWorks" : "Como é que isto funciona 😎",
      "howItWorks2" : "Como isto funciona",
      "addCategoryMessage" : "Adicionar uma nova categoria",
      "assignCategoryMessage" : "Atribuir uma opção de Categoria a Todos",
      "editResultsMessage" : "Mostrar a pontuação da Categoria in Página de Resultados",
      "addCategory" : "Adicionar Categoria",
      "deleteCategoryAlertMessage" : "Excluir uma categoria resultará no restante dessa categoria in todas as opções",
      "editOrAddNewCategories" : "o utilizador pode Editar Ou Incluir novas Categorias",
      "toEvaluateTheResponder" : "Para Comparar a resposta Ativado com base em vários fatores",
      "showMultipleCategoryScore" : "Mostrar várias classificações da Categoria in Página de Resultados",
      "displayVaryingContent" : "Ecrã, visualização variante Conteúdo Ativado a Página de resultados dependente Ativado o nível de pontuação da Categoria",
      "theOptionFieldIsRequired" : "O campo da opção é obrigatório",
      "addManage" : "Adicionar / Gerir",
      "enterCategoryPlaceholder" : "Introduzir nome da categoria",
      "carouselAlt" : "Diapositivo de pré-visualização da categoria"
    },
    "quizSettings" : "Definições do questionário",
    "onQuizSubmission" : "Ao enviar o questionário",
    "settings" : "Definições",
    "deletePage" : "Eliminar página",
    "quizResult" : {
      "resultTemplate" : "Modelo de resultado",
      "quizResultAlertMessage" : "A página de resultados escolhida será apresentada assim que o questionário for concluído",
      "overallScoreLabel" : "Pontuação geral"
    },
    "autoResponderSubheader" : "Enviar um e-mail automático à pessoa que envia o questionário (o e-mail inclui uma cópia das informações introduzidas no questionário)",
    "sendSubmissionsAsPdf" : "Enviar submissão do questionário como um PDF",
    "sendQuizResultsAsPdf" : "Enviar resultado do questionário como um PDF",
    "integrateHeader" : "Integrar questionário",
    "integrateSubHeader" : "Utilize as seguintes opções para integrar o questionário personalizado no seu Website",
    "integrateCopyLinkMessage" : "Copie a ligação abaixo e partilhe-a facilmente onde quiser.",
    "pageLabel" : "Página {n}",
    "pageName" : "Nome da página",
    "pagePosition" : "Posição da página",
    "createContactOnPartialSubmissionSubText" : "Cria um contacto quando um utilizador clica em \"Seguinte\" em qualquer diapositivo — mesmo que não conclua o questionário.",
    "integratePopup" : {
      "shareOrEmbed" : "Incorporar ou Partilhar Questionário",
      "share" : {
        "openFormLink" : "Abrir Ligar, vincular do questionário"
      },
      "email" : {
        "emailSubheader" : "Criar um e-mail em branco e incluir o seu questionário, ou selecionar um modelo e incorporá-lo imediatamente."
      }
    }
  },
  "textEditor" : {
    "textAlign" : "Alinhamento do texto",
    "list" : "Lista",
    "sourceCode" : "Código-fonte",
    "resetStyle" : "Repor estilo",
    "resetDocumentStyle" : "Repor estilo do documento"
  }
}
